<template>
    <div class="content-banner">
        <div class="content-banner-itens">
            <img src="@/assets/img/banner/client.png" alt="">
            <div class="content-banner-itens-text container">
                <div>
                    <h1 class="v-content-client-banner" v-contentClientBanner="{ section: 'Banner', removeHtml: true }">
                        Nós damos os descontos, eles dão o sorriso.
                    </h1>
                    <button class="v-content-client-banner" v-contentClientBanner="{ section: 'Banner', removeHtml: true }" @click="goToComponent()">
                        Saiba mais
                    </button>
                </div>
            </div>

        </div>
    </div>
</template>
<script>
import axios from "axios";
import store from "@/store";

const allContents = [];
const lang = localStorage.getItem('locale') || 'es';

export default {
  name: "Banner",
  data() {
    return {};
  },
  methods: {
    goToComponent() {
        document.getElementById('form-contact').scrollIntoView({ behavior: 'smooth' });
    },
    updateDirectives() {
          const allElements = document.querySelectorAll('.v-content-client-banner');
          allContents.splice(0, allContents.length); // clear the contents array
          allElements.forEach((el) => {
              const params = el.dataset.params ? JSON.parse(el.dataset.params) : {};
              params.content = el.innerHTML.trim();
              (!('type' in params) ? params.type = 'text' : null);
              params.theme = process.env.VUE_APP_THEME;
              params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
              allContents.push(params);
          });
      },
  },
  created() {
      this.updateDirectives();
  },
  mounted() {},
  directives: {
      contentClientBanner: {
        inserted: async function (el, binding) {
          const allElements = document.querySelectorAll('.v-content-client-banner');
          let params = binding.value ? binding.value : {};
          params.content = el.innerHTML.trim();
          (!('type' in params) ? params.type = 'text' : null);
          params.theme = process.env.VUE_APP_THEME;
          params.url_full = `${document.location.protocol}//${document.location.hostname}${document.location.pathname}`;
          allContents.push(params);
  
          if (allElements.length == allContents.length) {
            store.dispatch('App/loading', true);
            await axios({
              method: "POST",
              url: '/api/v1/site/get-all-contents',
              data: { allContents, lang }
            })
              .then(response => response.data)
              .then((data) => {
  
                const allElements = document.querySelectorAll('.v-content-client-banner');
                allContents.forEach((el) => {
                  if (el.type == 'text') {
                    allElements.forEach((el, index) => {
                      el.innerHTML = data.data[index];
                    });
                  }
                });
                store.dispatch('App/loading', false);
              });
          }
        },
  
      }
    },
};
</script>
  
  <style lang="scss">
  .content-banner {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    @media screen and (max-width: 991px) {
        height: 594px;
        background-image: url('~@/assets/img/banner/client.png');
        background-repeat: no-repeat;
        background-size: cover;
        background-position: 83%;
    }
    &-itens{
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        color: #fff;
        font-size: 40px;
        font-weight: 700;
        text-align: left;
        position: relative;
        @media screen and (max-width: 991px) {
            align-items: flex-start;
            
        }
        img{
            width: 100%;
            height: auto;
            @media screen and (max-width: 991px) {
                display: none;
            }
        };
        &-text{
            position: absolute;
            width: 100%;
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            @media screen and (max-width: 991px) {
                width: 100%;
                padding-left: 0px;
            }
            div{
                width: 700px;
                height: 100%;
                display: flex;
                flex-direction: column;
                justify-content: flex-start;
                align-items: flex-start;
                text-align: left;
                padding-top: 250px;
                @media screen and (max-width: 1500px) {
                    width: 600px;
                    padding-top: 0px;
                    justify-content: center;
                }
                @media screen and (max-width: 1300px) {
                    width: 500px;
                }
                @media screen and (max-width: 1100px) {
                    width: 400px;
                }
                @media screen and (max-width: 991px) {
                    width: 100%;
                }
                h1{
                    font-family: 'Font Bold';
                    font-size: 60px;
                    line-height: 90px;
                    @media screen and (max-width: 1500px) {
                        font-size: 50px;
                        line-height: 70px;
                    }
                    @media screen and (max-width: 1300px) {
                        font-size: 40px;
                        line-height: 60px;
                    }
                    @media screen and (max-width: 1100px) {
                        font-size: 35px;
                        line-height: 50px;
                    }
                    @media screen and (max-width: 991px) {
                        font-size: 30px;
                        line-height: 40px;
                        max-width: 300px;
                        background-color: #3d1403a3;
                        padding: 30px;
                    }
                }
                button{
                    margin-top: 40px;
                    width: 260px;
                    height: 83px;
                    background-color: var(--white);
                    border: 1px solid var(--main-color);
                    box-shadow: 0px 3px 3px rgba(0, 0, 0, 0.25);
                    border-radius: 10px;
                    color: var(--main-color);
                    font-family: 'Font Medium';
                    font-size: 30px;
                    line-height: 46px;
                    cursor: pointer;
                    @media screen and (max-width: 1500px) {
                        width: 220px;
                        height: 70px;
                        font-size: 25px;
                        line-height: 40px;
                        margin-top: 35px;
                    }
                    @media screen and (max-width: 1300px) {
                        width: 180px;
                        height: 60px;
                        font-size: 20px;
                        line-height: 30px;
                        margin-top: 30px;
                    }
                    @media screen and (max-width: 1100px) {
                        width: 200px;
                        height: 55px;
                    }
                    @media screen and (max-width: 991px) {
                        margin-left: 30px;
                    }
                }
            }
        }
    }
  }
  </style>
  